import { useTranslation } from 'react-i18next'

import { Widget, WidgetContentItemsList } from '../../../Widget'
import { EmailProfileWidgetParticipantsItem } from '../EmailProfileWidgetParticipantsItem'

function EmailProfileWidgetParticipants({
  initiallyExpanded,
  isSkeleton,
  participants,
  widgetProps,
}) {
  const { t } = useTranslation()

  return (
    <Widget
      {...widgetProps}
      headerProps={{
        contentProps: {
          actionsProps: {
            EditButton: null,
          },
        },
      }}
      initiallyExpanded={initiallyExpanded}
      isSkeleton={isSkeleton}
      title={t('EmailProfile.ParticipantsWidgetTitleKey')}
    >
      <WidgetContentItemsList
        Item={EmailProfileWidgetParticipantsItem}
        items={participants}
        title={t('EmailProfile.ParticipantsWidgetListTitleKey', {
          count: participants?.length,
        })}
      />
    </Widget>
  )
}

export default EmailProfileWidgetParticipants
